import { useSelector } from "react-redux";
import {
  selectIsLoggedIn,
  selectUser,
} from "../../redux/features/auth/AuthSlice";

const OnlyLoginUser = ({ children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (isLoggedIn) {
    return <>{children}</>;
  }
  return null;
};

const OnlyLogoutUser = ({ children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (!isLoggedIn) {
    return <>{children}</>;
  }
  return null;
};

const AdminCashier = ({ children }) => {
  const user = useSelector(selectUser);

  if (user?.role === "admin" || user?.role === "cashier") {
    return <>{children}</>;
  }
  return null;
};

const AdminOnly = ({ children }) => {
  const user = useSelector(selectUser);

  if (user?.role === "admin") {
    return <>{children}</>;
  }
  return null;
};

export { OnlyLoginUser, OnlyLogoutUser, AdminCashier, AdminOnly };
